import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { ImageUpload } from "../../components/ImageUpload";

const resolveUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

export const AdminLookbookTab = ({ items, refresh }) => {
  const [pending, setPending] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const addImages = async (urls) => {
    setSubmitting(true);
    try {
      const startOrder = items.length;
      for (let i = 0; i < urls.length; i++) {
        await api.post("/admin/lookbook", { url: urls[i], order: startOrder + i });
      }
      setPending([]);
      await refresh();
    } catch {
      // ignore
    } finally {
      setSubmitting(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm("Remove this image from the lookbook?")) return;
    try {
      await api.delete(`/admin/lookbook/${id}`);
      await refresh();
    } catch {
      // ignore
    }
  };

  return (
    <section data-testid="admin-lookbook-section">
      <div className="flex items-center justify-between mb-4">
        <p className="font-mono text-xs tracking-[0.3em] text-kult-yellow">/ LOOKBOOK</p>
      </div>

      <div className="border-2 border-kult-pink p-6 bg-kult-black2 mb-6">
        <p className="font-display text-2xl mb-3">ADD TO LOOKBOOK</p>
        <p className="font-mono text-[11px] text-kult-muted mb-4">
          Upload one or more images. They'll be appended to the end of the lookbook.
        </p>
        <ImageUpload
          value={pending}
          onChange={(imgs) => {
            setPending(imgs);
            const newOnes = imgs.filter((u) => !pending.includes(u));
            if (newOnes.length) addImages(newOnes);
          }}
          max={20}
          testIdPrefix="lookbook-add"
          recommendedSize="1600×2000 (4:5 portrait) — high-res editorial"
        />
        {submitting && <p className="font-mono text-xs text-kult-yellow mt-2">SAVING...</p>}
      </div>

      <p className="font-mono text-xs tracking-[0.3em] text-kult-muted mb-3">
        CURRENT LOOKBOOK · {items.length} {items.length === 1 ? "image" : "images"}
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="admin-lookbook-grid">
        {items.map((it) => (
          <div key={it.id} className="relative aspect-[4/5] border border-kult-border" data-testid={`admin-lookbook-${it.id}`}>
            <img src={resolveUrl(it.url)} alt={it.caption || ""} className="w-full h-full object-cover" />
            <button
              onClick={() => del(it.id)}
              className="absolute top-2 right-2 bg-black/80 border border-kult-border p-1.5 hover:bg-kult-pink hover:text-black"
              data-testid={`admin-lookbook-delete-${it.id}`}
              aria-label="Delete"
            >
              <Trash2 size={12} />
            </button>
          </div>
        ))}
        {items.length === 0 && (
          <p className="col-span-full font-mono text-sm text-kult-muted py-10 text-center">
            Empty for now. Upload images above.
          </p>
        )}
      </div>
    </section>
  );
};
